// Hidden drafts (cancelled schedules) carry a year-9999 sentinel date.
export const isDraftDate = (raw) => String(raw || '').startsWith('9999');

// UTC ISO → local `datetime-local` value; drafts show as empty.
export const toLocalInput = (raw) => {
  if (!raw || isDraftDate(raw)) return '';
  const d = new Date(raw);
  return isNaN(d) ? '' : new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
};

// Empty field on a draft keeps it hidden; empty otherwise = publish now.
export const scheduleForSave = (localValue, originalRaw) => {
  if (localValue && localValue.trim()) return new Date(localValue).toISOString();
  return isDraftDate(originalRaw) ? originalRaw : '';
};

export const DRAFT_HINT = 'Entwurf (für Schüler unsichtbar). Leer lassen = bleibt verborgen, Datum wählen = neu planen.';

export const scheduleBadgeText = (raw) =>
  (isDraftDate(raw) ? 'Entwurf · unsichtbar' : `Geplant · ${new Date(raw).toLocaleDateString('de-DE')}`);

export const scheduleFieldLabel = (raw) =>
  (isDraftDate(raw) ? 'Neu planen am (leer = bleibt Entwurf)' : 'Veröffentlichen am (leer = sofort)');
